import {
  ListItemIcon,
  ListItemText,
  MenuItem as MuiMenuItem,
} from "@mui/material";
import { type ComponentProps, type MouseEvent, type ReactNode } from "react";

type MenuItemProps = Pick<
  ComponentProps<typeof MuiMenuItem>,
  "disabled" | "selected" | "className"
> & {
  children?: ReactNode;
  label?: ReactNode;
  secondaryLabel?: ReactNode;
  startIcon?: ReactNode;
  onClick?: (event: MouseEvent<HTMLLIElement>) => void;
};

export function MenuItem({
  children,
  label,
  secondaryLabel,
  startIcon,
  onClick,
  disabled,
  selected,
  className,
}: MenuItemProps) {
  return (
    <MuiMenuItem
      onClick={onClick}
      disabled={disabled}
      selected={selected}
      className={className}
    >
      {children ?? (
        <>
          {startIcon && <ListItemIcon>{startIcon}</ListItemIcon>}
          <ListItemText primary={label} secondary={secondaryLabel} />
        </>
      )}
    </MuiMenuItem>
  );
}
